import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import { PRBottlerSelectionProvider } from "../../../context/PRBottlerSelectionContext";
import { PRCustomBottlerSelectionProvider } from "../../../context/PRCustomBottlerSelectionContext";
import PRManageForecastMainContent from "./PRManageForecastMainContent";
import { setActiveDataElement } from "../../../redux/userSlice";

const PRManageForecast = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("Production Requirement"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection title="Manage Production Requirement File" />
            <div className="container">
              <PRBottlerSelectionProvider>
                <PRCustomBottlerSelectionProvider>
                  <PRManageForecastMainContent></PRManageForecastMainContent>
                </PRCustomBottlerSelectionProvider>
              </PRBottlerSelectionProvider>
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default PRManageForecast;
